import React from "react";
import { Link, useLocation } from "react-router-dom";
import Icons from "../myIcon/Icons";

export default function Footer({footerHide, branchContent}) {
    const location = useLocation();
    
    const pathParts = location.pathname.split("/").filter(Boolean);
    const BranchName = pathParts[0] || "";

    // default branch
    const defaultBranch = {
        address: "CP-01, Eldeco Samridhi Udyan-2, Raksha Khand, Sharda Nagar, Raibareli Road, Lucknow",
        email: "lpsheadoffice@lpgs.co.in",
        phone: "8005488416",
        branch_slug: null,
        isDefault: true,
    };
    
    const footerBranch =
    Object.entries(branchContent).find(([slug]) =>
      BranchName.includes(slug)
    )?.[1] || defaultBranch;


    const disclosureLink = footerBranch?.branch_slug
    ? `/${footerBranch.branch_slug}/disclosure`
    : "/disclosure";


    // hide disclosure link for this branch
    const hideDisclosure = ["lps-school-pragatipuram", "lps-school-unnao-sector-c",].includes(BranchName);

  return (
    <>
      <footer className={`footer ${footerHide || ""}`}>
        <div className="container">
            <div className="row">               
                <div className="col-lg-5 col-md-4">
                    <div className="footer-logo">
                        <img src="/image/logo.png" className="img-responsive" alt="Logo" loading="lazy"/>

                        {footerBranch && (
                        <ul className="footer-address">
                            <li>{footerBranch.address}</li>  
                            <li><Link to={`mailto:${footerBranch.email}`}>{footerBranch.email}</Link></li>
                            <li>
                                <Link to={`tel:${footerBranch.phone}`}>{footerBranch.phone}</Link>
                            </li>
                        </ul>
                        )}
                    </div> 

                    {/* <li><Link to="/image/Newsletter-July-2026.pdf" className="" target="_blank" rel="noopener noreferrer">Newsletter - july 2026</Link></li> */}
                </div>

                <div className="col-lg-7 col-md-8">
                    <div className="row">
                        <div className="col-lg-12">
                            <h4 className="footer-linkhead">Useful Links</h4>
                        </div>

                        <div className="col-lg-4 col-sm-4 col-md-4 col-6">
                            <ul className="footer-links">
                                <li><Link to={"/our-heritage"}>About Us</Link></li>
                                <li><Link to={"/why-lps-lucknow-public-school"}>why LPS</Link></li>
                                <li><Link to={"/admission-process"}>Admissions</Link></li>
                                <li><Link to={"/contact"}>Contact us</Link></li>
                                {/* <li><Link to={"/calendar"}>Calendar</Link></li> */}
                            </ul>
                        </div>

                        <div className="col-lg-4 col-sm-4 col-md-4 col-6">
                            <ul className="footer-links">

                                <li><Link to={"/student"}>student life</Link></li>
                                <li><Link to={"/teacher"}>Teacher</Link></li>
                                <li><Link to={"/parents"}>parents</Link></li>
                                <li><Link to={"/alumni"}>Alumni</Link></li>
                            </ul>
                        </div>

                        <div className="col-lg-4 col-sm-4 col-md-4 col-12">
                            <ul className="footer-links">
                                <li><Link to={"/blog"}>Blog</Link></li>
                                <li><Link to={"/news"}>News & Media</Link></li>
                                {/* {!footerBranch?.isDefault && (
                                    <li><Link to={disclosureLink}>Disclosure</Link></li>
                                )} */}

                                {!footerBranch?.isDefault && !hideDisclosure && (
                                    <li><Link to={disclosureLink}>Disclosure</Link></li>
                                )}
                                <li><Link to={"/privacy-policy"}>Privacy Policy</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="col-lg-12">
                    <div className="footer-copyright">              
                        <p>© 2025 LPSC | Designed by <a href="https://www.88gravity.com" target="_blank" rel="noopener noreferrer">88gravity</a></p>
                        <ul className="footer-social">
                            <li><Link to={"https://www.linkedin.com/company/lucknow-public-school-official/"} target="_blank" aria-label="instagram"><Icons name="linkedin"/></Link></li>
                            <li><Link to={"https://www.facebook.com/lpscpsingh/"} target="_blank" aria-label="Facebook"><Icons name="facebook"/></Link></li>
                            <li><Link to={"https://www.instagram.com/lucknowpublicschoolofficial?igsh=MW42aXVnbGExam43eQ=="} target="_blank" aria-label="instagram"><Icons name="instagram"/></Link></li>
                            <li><Link to={"https://www.youtube.com/@lucknowpublicschoolofficial"} target="_blank" aria-label="youtube"><Icons name="youtube"/></Link></li>
                        </ul>
                    </div>
                </div>

            </div>
          </div>
      </footer>

      <a href="/image/Walk-In-Interview-LPS.pdf" download className="jobopen" rel="noopener noreferrer"><img src="/image/jobhire.png" alt="job"/></a>
    </>
  )
}
